import * as React from 'react';
import { useForkRef } from '../../../hooks';
import { useScrollerContext } from '../Scroller.context';
import { Styler, StylerProps } from '../../Styler';

export interface ScrollerItemProps extends StylerProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    /**
     * If `true`, the scroller will attempt to keep this item in view.
     * @default false
     */
    active?: boolean;
}

export function ScrollerItem(props: Readonly<ScrollerItemProps>): React.JSX.Element {
    const { children, active = false, ref, ...other } = props;

    const context = useScrollerContext();

    const elementRef = React.useRef<HTMLElement | null>(null);
    const handleRef = useForkRef(elementRef, ref);

    React.useEffect(() => {
        if (active) {
            context?.onChangeActiveItem(elementRef.current);
        }
    }, [active, context]);

    return (
        <Styler
            component="li"
            ref={handleRef}
            data-scroller-item={true}
            data-active={active || undefined}
            role="presentation"
            {...other}
        >
            {children}
        </Styler>
    );
}
